const Settings = () => {
  return (
    <div className="admin-settings">
      <h2>설정</h2>
      <div className="settings-section">
        <h3>사이트 설정</h3>
        <p>현재 설정 기능은 준비 중입니다.</p>
      </div>
    </div>
  );
};

export default Settings;
